export const userRole = {
	CLIENT: 'client',
	EXPERT: 'expert',
	UNDEFINED: 'undefined',
};
